declare const require: any;

export const environment = {
    production: true,
    oneTrustKey: '8011c6b0-dae6-4989-906d-2224bcf85e23',
    version: require('../../package.json').version
};
